import React from 'react';

export const Equipments = () => {
    return (
        <div>
            Equipments Page
        </div>
    );
};